module.exports = __webpack_public_path__ + "img/data2.a63de3f1.jpg";